export const PAYSERVICE_ROUTING = [
    {
        path: '/payservice',
        name: 'payservice',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Thanh toán hộ', pathName: 'payservice', icon: 'fa fa-credit-card' },
            ]
        },
        component: () => import('./PayService.vue'),
        redirect: { name: 'payservice-index' },
        children: [
            { 
                path: '/thanh-toan-ho.html',
                name: 'payservice-index',
                component: () => import('./components/main-payservice/MainPayService.vue')
            },
            {
                path: '/thanh-toan-ho/payservice-new.html',
                name: 'payservice-new',
                meta: {
                    breadcrumb: [
                        { name: 'Tạo mới thanh toán hộ', pathName: 'payservice-new', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/add-new-payservice/AddNewPayService.vue'),
            },
            {
                path: '/thanh-toan-ho/:id',
                name: 'payservice-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết thanh toán hộ', pathName: 'payservice-detail', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/detail-payservice/DetailPayService.vue'),
            }
        ]
    }
];